import { useContext } from 'react';

import { GlobalSearchContext } from './index';

export function useGlobalSearch() {
  return useContext(GlobalSearchContext);
}
